import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Meta from "../Meta";
import Loader from "../loader";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { applyLang } from "../../../i18n";
import renderIcon from "../../../components/renderIcon";
import { getBethHabadLabel } from "../utils";

const horairesStyles = `
.tr-horaires__title {
  font-size: clamp(20px, 3.5vw, 32px);
  font-weight: 700;
  color: #1a1a2e;
  text-align: center;
  margin: 64px 0 12px;
}
.tr-horaires__subtitle {
  text-align: center;
  font-size: clamp(16px, 2vw, 20px);
  color: #555;
  margin: 0 0 40px;
  font-weight: 400;
}
.tr-horaires__card {
  max-width: 820px;
  margin: 0 auto 60px;
  background: white;
  border-radius: 20px;
  box-shadow: 0 4px 24px rgba(0,0,0,.08), 0 1px 4px rgba(0,0,0,.04);
  padding: 32px 36px;
}
.tr-horaires__head {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #eee;
}
.tr-horaires__head-icon {
  color: var(--primary, #1b579e);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: color-mix(in srgb, var(--primary, #1b579e) 12%, white);
  flex-shrink: 0;
}
.tr-horaires__head-title {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a2e;
}
.tr-horaires__rich {
  font-size: 15px;
  color: #1f2937;
  line-height: 1.7;
}
.tr-horaires__rich h1,
.tr-horaires__rich h2,
.tr-horaires__rich h3 {
  color: #1a1a2e;
  margin-top: 24px;
  margin-bottom: 10px;
}
.tr-horaires__rich p { margin: 0 0 12px; }
.tr-horaires__rich a { color: var(--primary, #1b579e); text-decoration: underline; }
.tr-horaires__rich ul, .tr-horaires__rich ol { padding-left: 22px; margin: 0 0 14px; }
.tr-horaires__rich table {
  width: 100%;
  border-collapse: collapse;
  margin: 14px 0;
}
.tr-horaires__rich th,
.tr-horaires__rich td {
  border: 1px solid #e5e7eb;
  padding: 8px 12px;
  text-align: start;
}
.tr-horaires__rich th {
  background: #f9fafb;
  font-weight: 600;
}

.tr-horaires__empty {
  max-width: 560px;
  margin: 40px auto 80px;
  text-align: center;
  color: #6b7280;
  font-size: 15px;
}

@media (max-width: 640px) {
  .tr-horaires__card { padding: 22px 20px; margin: 0 16px 40px; }
}
`;

export default function Horaires({ context, loading }) {
    const { org, config, travel } = context;

    const horaires = applyLang(travel?.horaires || {}, context.lang);
    const html = horaires.content;
    const bethHabadLabel = getBethHabadLabel(travel, context.lang);

    return (
        <div className="travel-page travel-page--horaires tr-horaires">
            <style dangerouslySetInnerHTML={{ __html: horairesStyles }} />
            <Meta
                context={context}
                title={t`Horaires — ${org.ville || org.name}`}
                description={config["meta.description"] || t`Horaires du ${bethHabadLabel} de ${org.ville || org.name}`}
            />

            {loading && <Loader />}
            <Header context={context} />

            <main className="travel-main">
                <div className="travel-container">

                    <h1 className="tr-horaires__title">
                        <Trans>Horaires à</Trans>{" "}{org.ville || org.name}
                    </h1>

                    <div className="tr-horaires__subtitle">
                        <Trans>Retrouvez ici tous les horaires de la communauté</Trans>
                    </div>

                    {html ? (
                        <div className="tr-horaires__card">
                            <div className="tr-horaires__head">
                                <div className="tr-horaires__head-icon">
                                    {renderIcon({ name: "IconClock24", source: "tabler" }, 24)}
                                </div>
                                <div className="tr-horaires__head-title">
                                    <Trans>Horaires</Trans>
                                </div>
                            </div>
                            <div
                                className="tr-horaires__rich"
                                dangerouslySetInnerHTML={{ __html: html }}
                            />
                        </div>
                    ) : (
                        <div className="tr-horaires__empty">
                            <Trans>Aucun horaire n'a été renseigné pour le moment.</Trans>
                        </div>
                    )}

                </div>
            </main>

            <Footer context={context} />
        </div>
    );
}
